import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material';
import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { CaixaService } from 'app/service/caixa/caixa.service';
import { CaixaModel } from 'app/model/caixa/caixa.model';
import { ActivatedRoute } from '@angular/router';
import { ConteudoService } from 'app/service/caixa/conteudo.service';
import { EventEmitterService } from 'app/service/event-emitter-service';


@Component({
  selector: 'app-relatorio-auditoria',
  templateUrl: './relatorio-auditoria.component.html',
  styleUrls: ['./relatorio-auditoria.component.scss']
})
export class RelatorioAuditoriaComponent implements OnInit, OnDestroy {
  caixaId;
  deData;
  public caixa = {} as CaixaModel;
  conteudosAny: any[] = [];
  tiposDoc : any[] = [];;
  loading = true;
  dateTime;
  public rgCaixa;
  public auditoria: any[] = [];
  public auditoriaMigracao: any[] = [];
  public caixaMigrada = false;
  dataSource = new MatTableDataSource<any[]>([]);
  displayedColumns = ['ocorrencia', 'usuario', 'data'];
  constructor(
    private route: ActivatedRoute,
    private caixaService: CaixaService,
    private conteudoService: ConteudoService) {
    EventEmitterService.get("isPrintPage").emit(true);
    this.route.params.subscribe(params => this.caixaId = params['id']);
    this.deData = CryptoJS.AES.decrypt(decodeURIComponent(this.caixaId), 'pcdoc');
    this.caixaId = JSON.parse(this.deData.toString(CryptoJS.enc.Utf8));
   }

  ngOnInit() {
    let date = new Date();
    this.dateTime = date.toLocaleString('pt-BR');
    this.getDadosCaixa(this.caixaId);
    this.rastreabilidadeCaixa(this.caixaId);
  }

  ngOnDestroy(): void {
    EventEmitterService.get("isPrintPage").emit(false);
  }

  getDadosCaixa(caixaId) {
    this.caixaService.getCaixaUnica(caixaId).subscribe(data => {
      console.log(data);
      this.caixa = data;
      this.loading = false;
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  rastreabilidadeCaixa(caixaId) {
    this.caixaService.rastreabilidadeCaixa(caixaId).subscribe(data => {
      const size = data.length;
      if (size > 0) {
        this.caixaMigrada = false;
        this.auditoria = data;
        this.loading = false;
      } else {
        this.rastreabilidadeCaixaMigrada(caixaId);
      }
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  rastreabilidadeCaixaMigrada(caixaId) {
    this.caixaService.rastreabilidadeCaixaMigrada(caixaId).subscribe(data => {
      this.caixaMigrada = true;
      this.auditoriaMigracao = data;
      this.loading = false;
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/auditoria-caixa/relatorio-auditoria/relatorio-auditoria.component.ts